import { Clock, MessageCircle, Paperclip, Sparkles, User } from "lucide-react";
import { ChannelBadge, ChannelIcon } from "./channel-type";
import { Activity } from "../../../crm-pages/activities/types";

export const ActivityCard: React.FC<{ activity: Activity }> = ({ activity }) => {
  return (
    <div className=" border border-slate-200 p-4 sm:p-6 hover:shadow rounded-xl transition-shadow">
      <div className="flex gap-4">
        {/* Icon and Timeline */}
        <div className="flex flex-col items-center">
          <ChannelIcon channel={activity.channel} />
          <div className="w-px h-full bg-slate-200 mt-2" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-3">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-8 h-8 rounded-full bg-indigo-500 text-white flex items-center justify-center text-sm font-semibold flex-shrink-0">
                  {activity.customer.initials}
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-semibold text-lg text-slate-900 truncate">{activity.customer.name}</h3>
                  <p className="text-sm text-slate-500 truncate">{activity.customer.company}</p>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <ChannelBadge channel={activity.channel} />
              <div className="flex items-center gap-1 text-slate-500 text-sm whitespace-nowrap">
                <Clock className="w-4 h-4" />
                <span>{activity.timestamp}</span>
              </div>
            </div>
          </div>

          <h4 className="font-semibold text-slate-900 mb-1">{activity.title}</h4>
          <p className="text-slate-600 mb-3">{activity.description}</p>

          {/* Metadata */}
          <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500">
            {activity.agent && (
              <div className="flex items-center gap-1">
                <User className="w-4 h-4" />
                <span>{activity.agent}</span>
              </div>
            )}
            {activity.duration && (
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4" />
                <span>{activity.duration}</span>
              </div>
            )}
            {activity.attachments && (
              <div className="flex items-center gap-1">
                <Paperclip className="w-4 h-4" />
                <span>{activity.attachments} attachments</span>
              </div>
            )}
            {activity.messages && (
              <div className="flex items-center gap-1">
                <MessageCircle className="w-4 h-4" />
                <span>{activity.messages} messages</span>
              </div>
            )}
            {activity.score && (
              <div className="flex items-center gap-1">
                <Sparkles className="w-4 h-4" />
                <span>Score: {activity.score}</span>
              </div>
            )}
            {activity.tag && (
              <span className="italic text-slate-400">"{activity.tag}"</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};